import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteAnalytics from "@/components/Analytics";
import Landing from "@/pages/Landing";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Editor from "@/pages/Editor";
import Sponsors from "@/pages/Sponsors";
import Marketplace from "@/pages/Marketplace";
import Analytics from "@/pages/Analytics";
import Repurpose from "@/pages/Repurpose";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Refund from "@/pages/legal/Refund";
import Contact from "@/pages/legal/Contact";
import PublicFit from "@/pages/PublicFit";
import ReplyConfirm from "@/pages/ReplyConfirm";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/billing/success" element={<BillingSuccess />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/refund" element={<Refund />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/fit" element={<PublicFit />} />
      <Route path="/fit/:slug" element={<PublicFit />} />
      <Route path="/r/:token" element={<ReplyConfirm />} />
      <Route element={<AppLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/editor" element={<Editor />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/repurpose" element={<Repurpose />} />
      </Route>
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <SiteAnalytics />
            <AppRouter />
            <Toaster
              position="bottom-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#0e0e0f",
                  border: "1px solid #27272a",
                  color: "#ffffff",
                  borderRadius: "2px",
                  fontFamily: "Satoshi, ui-sans-serif",
                },
              }}
            />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}
